import { Injectable } from '@angular/core';

import { LocalStorageService, SessionStorageService } from '../web-storage';

import { JwtHelperService } from '@auth0/angular-jwt';

const accessTokenKey = 'access_token';

/** Service para trabalhar com o JWT (JSON Web Token) */
@Injectable({
    providedIn: 'root'
})
export class JwtService {
    jwtHelper: JwtHelperService;

    constructor(private sessionStorage: SessionStorageService,
                private localStorage: LocalStorageService) {
        this.jwtHelper = new JwtHelperService();
    }

    get accessToken(): string {
        // Primeiro tenta recuperar o JWT do Session Storage
        const accessTokenSession = this.sessionStorage.get(accessTokenKey);
        if (accessTokenSession && accessTokenSession !== '') {
            return accessTokenSession;
        }

        // Se não existir no Session Storage, tenta recuperar do Local Storage
        return this.localStorage.get(accessTokenKey);
    }

    /** Adiciona o JWT no Web Storage */
    setAccessToken(accessToken: string, stayConnected: boolean) {
        // Se o token possuir valor
        if (accessToken) {
            this.sessionStorage.set(accessTokenKey, accessToken)

            // Se for para permanecer conectado salvamos o token também no Local Storage
            if (stayConnected) {
                this.localStorage.set(accessTokenKey, accessToken);
            }
        } else {
            // Caso o token não possui valor, removemos do local storage
            this.remove();
        }
    }

    get accessTokenWithBearer(): string {
        return `Bearer ${this.accessToken}`;
    }

    /**
     * Decodifica o token de acesso
     */
    decodeToken(): any {
        return this.jwtHelper.decodeToken(this.accessToken);
    }

    /**
     * Pega a data de expiração do token de acesso
     */
    getTokenExpirationDate(): Date {
        return this.jwtHelper.getTokenExpirationDate(this.accessToken);
    }

    /**
     * Verifica se o token de acesso está expirado ou não
     */
    isTokenExpired(): boolean {
        return this.jwtHelper.isTokenExpired(this.accessToken);
    }

    /**
     * Remove o access_token do local storage
     */
    remove() {
        this.sessionStorage.remove(accessTokenKey);
        this.localStorage.remove(accessTokenKey);
    }
}
